import React from 'react'
import { connect } from 'react-redux'
import ColourActions from '../../Redux/ColourRedux'
import { currentBranch } from '../../Utils/PrivilegeUtils'

class CreateColour extends React.Component {
  constructor (props) {
    super(props)
    this.branch = currentBranch()
    this.state = {
      form: {
        name: '',
        colour_code: '#f89924'
      }
    }
  }

  _inputChange = (event, field) => {
    let value = event.target.value
    let form = { ...this.state.form }
    form[field] = value
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let data = { ...this.state.form }
    data.iso_code = this.branch
    this.props.createColour(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Type Creation</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Type</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                required
                placeholder='Insert type name'
                className='form-control'
                value={this.state.form.name}
                onChange={(event) => this._inputChange(event, 'name')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Type Color Code</label>
            </div>
            <div className='col-3'>
              <input
                type='color'
                name='colour-picker'
                style={{ width: '100%', height: '38px' }}
                value={this.state.form.colour_code}
                onChange={(event) => this._inputChange(event, 'colour_code')}
              />
            </div>
            <div className='col-6'>
              <input
                className='form-control'
                type='text'
                value={this.state.form.colour_code}
                readOnly
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  createColour: (data) => dispatch(ColourActions.createColourRequest(data))
})

export default connect(stateToProps, dispatchToProps)(CreateColour)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/CreateColour.js